import { ArslActionAlignText, ArsListingState } from "../interface";

/**
 * Updates header or body text alignment for a listing column.
 *
 * @param state - Current ARS listing state
 * @param action - Alignment action describing the target column and alignment scope
 * @returns Updated ARS listing state with the requested alignment applied
 */
export const arsl_alignText = <T>(
  state: ArsListingState<T>,
  action: ArslActionAlignText,
): ArsListingState<T> => {
  const updatedColumns = state.bodyData.arsListingColumns.map((column) =>
    column.id === action.colId
      ? {
          ...column,
          [action.isHeader ? "headerTextAlignment" : "bodyTextAlignment"]: action.alignment,
        }
      : column,
  );

  return {
    ...state,
    changed: true,
    bodyData: {
      ...state.bodyData,
      arsListingColumns: updatedColumns,
    },
  };
};
